import { useEffect } from 'react';
import { CircleChevronUp } from 'lucide-react';
import Header from '@/components/Header/header.jsx';
import Footer from '@/components/Footer/footer.jsx';
import HeadTag from '@/components/Head/Head.jsx';
import styles from './layout.module.scss';
import { useSelector } from 'react-redux';

// components
import Sidebar from '@/components/Sidebar';
import ScrollToTop from '@/components/ScrollToTop/ScrollToTop';

// utils
import { initIsMobile } from "@/utils/methods";

export default function Layout({ children, initialDeviceType }) {
    // 优先使用服务端传递的设备类型，避免延迟
    const isMobile = initialDeviceType === 'mobile';
    const { menuData, currentGame } = useSelector((state) => state.game);
    const { page_name } = children.props;

    const scrollToTop = () => {
        if (isMobile) {
            document.body.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // 设备类型判断现在直接使用服务端传递的参数，避免延迟

    const isApp = ['app', 'library', 'm_play'].includes(page_name);

    return (
        <>
            {/* 路由切换自动滚动到顶部 */}
            <ScrollToTop />
            
            {/* 背景色晕效果 */}
            <div className={styles.spot}>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <HeadTag />

            {/* 顶部导航 */}
            <Header 
                menuData={menuData}
                isMobile={isMobile}
            />
            <main className={`${styles.app_main} ${currentGame && isMobile ? styles.game_page_mobile : ''}`}>
                {/* <nav className={styles.nav_link}>
                    { !isMobile && <Sidebar menuData={menuData}/> }
                </nav> */}
                {children}
            </main>

            <Footer isMobile={isMobile} />

            <button 
                className={styles.scroll_top_button}
                onClick={scrollToTop}
                aria-label="Scroll to top"
            >
                <CircleChevronUp size={40} color='#666' />
            </button>
        </>
    );
}